import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RicambiService } from '../service/ricambi.service';
import { Categoria } from '../models/categoria';

@Component({
    selector: 'categoria',
    templateUrl: './tws-categoria.component.html',
    styleUrls: ['./tws-categoria.component.css']
})

export class TwsCategoriaComponent {
    
    categoriaCorrente: Categoria = new Categoria(0, '', '', 0);
    @Output() onSelectCategoria = new EventEmitter<Categoria>();
    @Input('categorie')
    tutteCategorie: Array<Categoria> = new Array<Categoria>();//in teoria ho l'albero e posso metterlo in cache
    @Input('custom')
    custom: boolean=false;
    constructor(private ricambiService: RicambiService) {

    }

    set categoria(cat: Categoria) {
        this.categoriaCorrente = cat;
    }

    set listaCategorie(cat: Array<Categoria>) {
        this.tutteCategorie = cat;
    }


    get categorie(): Array<Categoria> {
        let list: Categoria[] = this.tutteCategorie.filter(categoria => categoria.padre == this.categoriaCorrente.id);
        return list;
    }

    onSelect(hero: Categoria): void {
        this.categoriaCorrente = hero;
        this.onSelectCategoria.emit(hero);
    }

    ngOnInit() {
        if(!this.custom){
            this.ricambiService.getCategorie().then(heroes => { this.tutteCategorie = heroes; });
        }
    }

    get navigazione(): Array<Categoria> {
        let list: Categoria[] = new Array<Categoria>();
        let cat = this.categoriaCorrente;
        let l = new Array<Categoria>();
        while (cat.id > 0) {
            list.push(cat);
            l = this.tutteCategorie.filter(categoria => categoria.id == cat.padre);
            if (l.length > 0) {
                cat = l[0];
            } else {
                cat = new Categoria(0, "", "", 0);
            }
        }
        return list.reverse();
    }

}


// WEBPACK FOOTER //
// ./src/app/tws-categoria/tws-categoria.component.ts